import { string } from 'yup';
import { useTokenizedCardSelectorSchema } from '../../../../../payment/ui/credit-card/selector';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { ISelectCardFormData } from '../types/ISelectCardFormData';

export function useSelectCardSchema() {
	const tokenizedCardSelectorSchema = useTokenizedCardSelectorSchema();
	const { t } = useTranslation();

	return tokenizedCardSelectorSchema.shape<ISelectCardFormData>({
		tokenizedCardId: string().required(t('web_mandatory_field_error')),
	});
}
